import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import CarretDown from "@/assets/icons/ic-carret-down.svg?react";
import { useAuth } from "@/auth/auth.ts";
import { useStyles } from "@/hooks/useStyles";
import { Queries } from "@/queries/Queries";
import { Theme } from "@/theme/CreateTheme.ts";
import { MenuTooltip } from "@/uiKit/atoms/floating/MenuTooltip";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type AccountMenuProps = {
  className?: string;
};

export const AccountMenu: React.FC<AccountMenuProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const me = Queries.patient.useMe({});

  return (
    <MenuTooltip className={cx(className)} content={<MenuItems />} placement="bottom-end">
      <div className={styles.buttonContainer}>
        <Typography variant="body">
          {me.givenName} {me.familyName}
        </Typography>
        <CarretDown className={styles.icon} />
      </div>
    </MenuTooltip>
  );
};

export const MenuItems: React.FC = ({}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const { logout } = useAuth();
  return (
    <>
      <Typography variant="body" className={styles.menuItem} onClick={() => void logout()}>
        {t("auth.logout")}
      </Typography>
    </>
  );
};

const makeStyles = (theme: Theme) => ({
  buttonContainer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing(4)};
    padding: ${theme.spacing(4)};
    border-radius: ${theme.spacing(2)};
    &:hover {
      background-color: ${theme.palette.grey[100]};
    }
  `,
  menuItem: css`
    display: flex;
    flex-direction: row;
    padding: ${theme.spacing(4, 8)};
    cursor: pointer;
    &:hover {
      background-color: ${theme.palette.grey[100]};
    }
  `,
  icon: css`
    width: ${theme.typography.overline.fontSize};
    height: ${theme.typography.overline.fontSize};
  `,
});
